import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// Material setup
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { theme } from './styles/theme';
import { FeatureFlags } from './helpers';
import './styles/index.css';
import CssBaseline from '@mui/material/CssBaseline';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}
declare module '@mui/material/styles' {
  interface Palette {
    accent: {
      main: string;
    };
    typography: {
      labels: string;
      tableHeaders: string;
    };
  }
  // allow configuration using `createTheme`
  interface PaletteOptions {
    accent?: {
      main?: string;
    };
    typography?: {
      labels?: string;
      tableHeaders?: string;
    };
  }
  interface Palette {
    tertiary: {
      light: string;
      main: string;
      dark: string;
      contrastText: string;
    };
  }
  // allow configuration using `createTheme`
  interface PaletteOptions {
    tertiary?: {
      main?: string;
      light?: string;
      dark?: string;
      contrastText?: string;
    };
  }
}

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

let buildConfig = require('../src/buildSettings.json');

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: `${buildConfig.REACT_APP_LD_CLIENT_SIDE_KEY}`,
    flags: FeatureFlags,
    options: {
      evaluationReasons: true
    }
  });

  ReactDOM.render(
    <LDProvider>
      <StyledEngineProvider injectFirst>
        <MsalProvider instance={msalInstance}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </MsalProvider>
      </StyledEngineProvider>
    </LDProvider>,
    document.getElementById('root')
  );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
